export default __webpack_public_path__ + "203f4863ad9e0d526845bcc098c61f8a.svg";